
import { Component, inject, NgModule, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TdsIcon, TegelModule } from '@scania/tegel-angular-17';
import { AnalyticsService } from '@shared/services/analytics/analytics.service';

@NgModule({ imports: [TegelModule], exports: [TdsIcon] })
export class NoLongerValidTdsModule {}
@Component({
  selector: 'booking-no-longer-valid',
  imports: [NoLongerValidTdsModule, TranslateModule],
  templateUrl: './no-longer-valid.component.html',
  styleUrls: ['./no-longer-valid.component.scss']
})
export class NoLongerValidComponent implements OnInit {
  private analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.analyticsService.pushPageViewEvent('sp:external:invalid-link');
  }
}
